import { AxiosRequestConfig } from 'axios';
import { getUrlParam, updateURLParam } from '@utiljs/param';
import set from '@utils/set';
import { getCookie } from '@utiljs/cookie';

// 判断是否强制走中心
const forceToCenterSetList = [
    '/v2/logon/pass/step2/sendSms',
    '/v2/logon/pass/step2/verify',
    '/gw/account/phone/send/sms',
    '/v2/epassport/logon',
];

// PC大连锁切换到单门店走Set
const getRegionForSingleLisy = [
    '/gw/api/order/mix/unprocessed/list/common',
    '/gw/api/order/mix/unprocessed/count/common',
    '/gw/api/order/mix/history/list/common',
    '/gw/api/order/mix/pre/list/common',
    '/gw/api/order/mix/new/interval/list/common',
    '/gw/api/audit/majorDispute/getOrderDetail',

    '/gw/api/unified/r/order/list/count',
    '/gw/api/unified/r/order/list/page/unprocessed',
    '/gw/api/unified/r/order/list/page/history',
    '/gw/api/unified/r/order/list/page/preorder',
    '/gw/api/unified/r/order/list/interval',
];

const onFulfilled = (config: AxiosRequestConfig) => {
    const url = config.url || '';
    const isForceToCenter = forceToCenterSetList.indexOf(url) !== -1;
    const isGetRegionForSingle = getRegionForSingleLisy.indexOf(url) !== -1;
    const setParams = set.getParams({ isForceToCenter });
    let finalUrl = url;

    if (
        getUrlParam('region_id', url) ||
        getUrlParam('region_version', url) ||
        getUrlParam('ignoreSetRouterProxy', url)
    ) {
        // eslint-disable-next-line no-console
        console.error(
            'region_id, region_version 与 ignoreSetRouterProxy 为 SET 化保留参数，请勿设置',
        );
    }

    if (
        config &&
        config.params &&
        (config.params.region_id ||
            config.params.region_version ||
            config.params.ignoreSetRouterProxy)
    ) {
        // eslint-disable-next-line no-console
        console.error(
            'region_id, region_version 与 ignoreSetRouterProxy 为 SET 化保留参数，请勿设置',
        );
    }

    if (isGetRegionForSingle) {
        const setInfoSigle = getCookie('set_info_single');
        if (setInfoSigle) {
            let savedParams: any = null;
            try {
                savedParams = JSON.parse(decodeURIComponent(setInfoSigle));
            } catch (e) {
                savedParams = JSON.parse(setInfoSigle);
            }
            if (typeof savedParams === 'string') {
                savedParams = JSON.parse(savedParams);
            }
            if (savedParams) {
                const regionIdForSingle = savedParams.regionIdForSingle;
                const regionVersionForSingle = savedParams.regionVersionForSingle;
                if (regionIdForSingle)
                    finalUrl = updateURLParam(finalUrl, 'region_id', regionIdForSingle);
                if (regionVersionForSingle)
                    finalUrl = updateURLParam(finalUrl, 'region_version', regionVersionForSingle);
            }
        }
    }

    if (setParams) {
        if ('ignoreSetRouterProxy' in setParams && setParams.ignoreSetRouterProxy) {
            finalUrl = updateURLParam(finalUrl, 'ignoreSetRouterProxy', 'true');
        } else if ('region_id' in setParams && 'region_version' in setParams) {
            finalUrl = updateURLParam(finalUrl, 'region_id', setParams.region_id);
            finalUrl = updateURLParam(finalUrl, 'region_version', setParams.region_version);
        }
    }

    config.url = finalUrl;
    return config;
};

export default {
    onFulfilled,
};
